<template>
  <el-dialog
    :visible.sync="visible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    title="绑定企业微信"
    width="420px"
    custom-class="qywx-bind-dialog"
  >
    <div class="qywx-bind-body">
      <div class="qywx-user-info">
        <img v-if="userAvatar" :src="userAvatar" class="qywx-user-avatar" alt="avatar" />
        <i v-else class="el-icon-user-solid qywx-user-avatar-icon"></i>
        <span class="qywx-user-name">{{ userNickname || username || '用户' }}</span>
      </div>
      <p class="qywx-bind-tip">请使用企业微信扫码完成账号绑定，绑定后方可正常使用！</p>
      <iframe
        ref="bindFrame"
        :src="iframeSrc"
        class="qywx-bind-iframe"
        frameborder="0"
        scrolling="no"
      />
      <div v-if="bindError" class="qywx-bind-error">{{ bindError }}</div>
      <div v-if="binding" class="qywx-bind-loading">绑定中，请稍候...</div>
    </div>
  </el-dialog>
</template>

<script>
import { bindOaUid } from '@/api/c/auth'
import { getUserProfile } from '@/utils/auth'

export default {
  name: 'QywxBindDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    const profile = getUserProfile() || {}
    return {
      iframeSrc: '',
      bindError: '',
      binding: false,
      userAvatar: profile.avatar || '',
      userNickname: profile.nickname || '',
      username: profile.username || profile.phone || '',
    }
  },
  watch: {
    visible: {
      handler(val) {
        if (val) {
          window.addEventListener('message', this.handleMessage)
          if (!this.iframeSrc) {
            this.fetchIframeSrc()
          }
        } else {
          window.removeEventListener('message', this.handleMessage)
        }
      },
      immediate: true,
    },
  },
  beforeDestroy() {
    window.removeEventListener('message', this.handleMessage)
  },
  methods: {
    fetchIframeSrc() {
      fetch('https://oa.meidawenhua.com/index/ground/oaPcPath?route=admin%2Fqywxbind')
        .then(res => res.text())
        .then(text => {
          this.iframeSrc = decodeURIComponent(text)
        })
        .catch(() => {})
    },
    handleMessage(event) {
      if (!event.data || event.data.type !== 'qywx_bind_success') return
      const { uid, userid } = event.data
      if (!uid) {
        this.bindError = '未获取到企微账号信息，请重试'
        return
      }
      this.doBind(uid, userid)
    },
    doBind(oaUid, qywxUserId) {
      this.binding = true
      this.bindError = ''
      bindOaUid({ oaUid, qywxUserId }).then(res => {
        this.binding = false
        if (res && res.code === 0) {
          this.$message.success('企微绑定成功')
          this.$emit('bind-success', oaUid)
        } else {
          this.bindError = (res && res.message) || '绑定失败，请重试'
        }
      }).catch(() => {
        this.binding = false
        this.bindError = '网络异常，请重试'
      })
    }
  }
}
</script>

<style>
.qywx-bind-dialog .el-dialog__body {
  padding: 16px 24px 24px;
}
</style>

<style scoped>
.qywx-bind-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.qywx-user-info {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  padding: 10px 16px;
  background: #f7f7f7;
  border-radius: 8px;
  width: 100%;
}
.qywx-user-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}
.qywx-user-avatar-icon {
  width: 40px;
  height: 40px;
  font-size: 24px;
  color: #999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.qywx-user-name {
  font-size: 15px;
  font-weight: 500;
  color: #222;
}
.qywx-bind-tip {
  font-size: 14px;
  color: #666;
  margin-bottom: 16px;
  text-align: center;
}
.qywx-bind-iframe {
  width: 360px;
  height: 380px;
  border: none;
}
.qywx-bind-error {
  margin-top: 12px;
  color: #f56c6c;
  font-size: 13px;
}
.qywx-bind-loading {
  margin-top: 12px;
  color: #409eff;
  font-size: 13px;
}
</style>
